module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- class has been renamed  phx-cell-edit-action-hidden to hide pencil asked by GCT but code has not been removed in case a rollback is needed -->\r\n<span class=\'phx-cell-edit-action-hidden\'></span>\r\n<!-- <span class=\'phx-cell-edit-action ui-icon ui-icon-pencil\'></span> -->';
}
return __p;
};
